import * as types from '../../mutation_type'


export default {
  exptype ({state, commit}, res) {
    commit(types.EXPTYPES, res)
  },
  areaArrayStore ({state}, res) {
      if(res.areainfo) { // 设置券卡专区信息
        console.log(res.areainfo,'areainfo')
        state.cardRule.areainfo = res.areainfo;
      }
      if(res.arrylist){
        state.cardRule.arrylist = res.arrylist;
      }
      if(res.defaultInfo) { // 设置默认商品信息
        console.log(res.defaultInfo,'res.defaultInfo1111111');
        if(res.defaultInfo.kindcode) {
          state.cardRule.defaultgoodscode = res.defaultInfo.kindcode;
          if(res.defaultInfo.type == 1) {
            state.cardRule.defaultgoodsname = res.defaultInfo.kindinfo;
          } else {
            state.cardRule.defaultgoodsname = res.defaultInfo.goodsname + ' ' + res.defaultInfo.kindinfo;
          }
        } else {
          state.cardRule.defaultgoodscode = '';
          state.cardRule.defaultgoodsname = '';
        }
      }
      if(res.baseInfo) { // 设置券卡规则基础信息
        state.cardRule.cardkind = res.baseInfo.ticketType; // 券卡类型
        state.cardRule.selnum = res.baseInfo.zoneGoodsNum; // 可选择商品数量
        state.cardRule.selzones = res.baseInfo.zoneNum; // 专区数量
        state.cardRule.usenum = res.baseInfo.count; // 券卡使用次数
        state.cardRule.cardprice = res.baseInfo.ticketPrice; // 券卡面值
        state.cardRule.cardsmallprice = res.baseInfo.ticketmallPrice; // 券卡售价
        state.cardRule.discount = res.baseInfo.discount; //折扣
        state.cardRule.startvaldate = res.baseInfo.startvaldate; // 起始有效期
        state.cardRule.endvaldate = res.baseInfo.endvaldate; // 结束有效期
        state.cardRule.bmodify = res.baseInfo.edit?1:0; // 是否级联修改
        state.cardRule.cardcategory = res.baseInfo.cardcategory; // 按量提货
        state.cardRule.tcCardcategory = res.baseInfo.tcCardcategory; // 按量提货
        state.cardRule.deCardcategory = res.baseInfo.deCardcategory; // 按量提货
        state.cardRule.goodspicknum = Number(res.baseInfo.goodspicknum); // 商品可兑换总数
        state.cardRule.minpicknumonce = Number(res.baseInfo.minpicknumonce); // 单次最少提货数
      }
      if(res.deleteTrue) { // 用于初始化券卡信息
        state.cardRule.cardkind =''; // 券卡类型
        state.cardRule.cardprice = ""; // 券卡面值
        state.cardRule.cardsmallprice = ""; // 券卡售价
        state.cardRule.discount = ""; //折扣
        state.cardRule.selnum = 1; // 可选择商品数量
        state.cardRule.selzones = 1; // 专区数量
        state.cardRule.defaultgoodscode = ''; // 默认商品的规格编号
        state.cardRule.defaultgoodsname = ''; // 默认商品的名称
        state.cardRule.usenum = 1; // 券卡使用次数
        state.cardRule.areainfo = []; // 专区设置信息
        state.cardRule.startvaldate = ''; // 起始有效期
        state.cardRule.endvaldate = ''; // 结束有效期
        state.cardRule.bmodify = 0; // 是否级联修改
        state.cardRule.cardcategory = false; // 按量提货
        state.cardRule.tcCardcategory = false; // 按量提货
        state.cardRule.deCardcategory =  false;// 按量提货
        state.cardRule.goodspicknum = 1; // 商品可兑换总数
        state.cardRule.minpicknumonce = 1; // 单次最少提货数
      }
  },
  setBdis ({state}, res) {
    state.bdis = res;
  },
  // 帮助文档显隐
  setHelp ({state}, res) {
    state.isHelp = res;
  },
  //更改系统皮肤
  updateSkinTheme ({state}, res) {
    state.updateSkin = res;
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/common/actions/actions.js